module.exports = __webpack_public_path__ + "static/tab_fct1-992000d8627e1891060e9a8fee96bc73.jpg";